import { Label } from '@monorepo/react-components';

export const PositionSideTag = ({ side }: { side: string }) => {
  const isSell = side?.toLowerCase() === 'sell';
  return <Label color={isSell ? 'colorError' : 'colorSuccess'}>{side}</Label>;
};
